// 表示/非表示切り替え
import commonClass from "./commonClass";

export default class toggleShowClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._parentSelector = '.js-tglshow_prt';
    this._triggerSelector = '.js-tglshow_trg';
    this._triggerMultiSelector = '.js-tglshow_trg_multi';
    this._targetSelector = '.js-tglshow_tgt';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    $(document).on('change', 'input[type="checkbox"]' + cls._triggerSelector, function() {
      cls._checkbox($(this));
    });

    $(document).on('change', 'input[type="checkbox"]' + cls._triggerMultiSelector, function() {
      cls._checkboxMulti($(this));
    });

    $(document).on('click', 'button' + cls._triggerSelector, function() {
      cls._btn($(this));
    });
  }

  // トリガーがチェックボックス用
  _checkbox($self) {
    var cls = this;
    var $self = $self;
    var $prt = $self.closest(cls._parentSelector);
    var $tgt = $prt.find(cls._targetSelector);

    if ($self.prop('checked')) {
      $tgt.stop().fadeIn('fast');
    } else {
      $tgt.stop().fadeOut('fast');
    }
    return false;
  }

  // トリガーがチェックボックス用（1つ以上checkedで要素表示）
  _checkboxMulti($self) {
    var cls = this;
    var $self = $self;
    var $prt = $self.closest(cls._parentSelector);
    var $tgt = $prt.find(cls._targetSelector);
    var $trgChecked = $prt.find(cls._triggerMultiSelector + ":checked");

    if($trgChecked.length){
      $tgt.stop().fadeIn('fast');
     } else {
      $tgt.stop().fadeOut('fast');
    }
    return false;
  }

  // トリガーがボタン用
  _btn($self) {
    var cls = this;
    var $self = $self;
    var $prt = $self.closest(cls._parentSelector);
    var $tgt = $prt.find(cls._targetSelector);

    if ($self.hasClass('is-hide')) {
      $tgt.stop().fadeIn();
    } else {
      $tgt.stop().fadeOut();
    }
    $self.toggleClass('is-hide');
    return false;
  }

}